import React, { useState } from 'react'
import { Button, Form, Modal, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DashboardMainTitle from '../../../dashboardTitle/DashboardMainTitle';
import '../style.scss'
import { toast } from 'react-toastify';
import { fetchSaloons } from '../../../../redux/action/saloons/saloons';
import { useDispatch } from 'react-redux';
import { fetchDeleteSaloon, fetchUpdateSaloon } from '../../../../redux/action/saloons/saloon';
import MainLoading from '../../../../utils/MainLoading';
import { useTranslation } from 'react-i18next';
import SimpleReactValidator from 'simple-react-validator';
import { useRef } from 'react';

const Saloons = (props) => {
  const [forceUpdate, setForceUpdate] = useState(0)
  const [name, setName] = useState();
  const [editid, setEditid] = useState();
  const [deleteId, setDeleteId] = useState()
  const [editSaloon, setEditSaloon] = useState(false)
  const [deleteSaloon, setDeleteSaloon] = useState(false)
  const dispatch = useDispatch()
  const {t} = useTranslation();

  const handleClose = () => { 
    setEditSaloon(false) 
    setDeleteSaloon(false) 
  }

  const handleDeleteModal = (id) => {
    setDeleteId(id)
    setDeleteSaloon(true)
  }

  const handleDelete = () => {
    dispatch(fetchDeleteSaloon(deleteId))
    setTimeout(function() {dispatch(fetchSaloons())}, 1000)
    setEditSaloon(false)
    setDeleteSaloon(false)
  }

  const handleEditSaloon = (e) => {
    setName(e.target.value)
  }

  const handleEdit = (name, id) => {
    setEditSaloon(true)
    setName(id);
    setEditid(name)
  }

  const validator = useRef(new SimpleReactValidator({
    messages: {
      required:"پر کردن این فیلد الزامی است"
    },
}))

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validator.current.allValid()) {
      dispatch(fetchUpdateSaloon(editid, name))
      setEditSaloon(false)
      setDeleteSaloon(false)
      setTimeout(function() {dispatch(fetchSaloons())}, 1000)
    } else {
      setForceUpdate(1)
      validator.current.showMessages()
      toast.dismiss()
      toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
    }
  };

    return (
      <>
        <DashboardMainTitle> {t("dashboard_nav_saloons")} </DashboardMainTitle>
        {props.data &&
          props.data.loading ?
            <MainLoading />
          :
          props.data.saloons.length ? 
            <div className='halls_table'>
              <Table responsive bordered>
                <thead>
                  <tr>
                    <th className='text-center col-4'>{t("hall")}</th>
                    <th className='text-center col-2'>{t("companies number")}</th>
                    <th className='text-center col-2'>{t("delete")}</th>
                    <th className='text-center col-2'>{t("edit")}</th>
                    <th className='text-center col-2'>{t("details")}</th>
                  </tr>
                </thead>
                <tbody>
                  {props.data.saloons.map(item => (
                      <tr key={item.id} id={item.id}>
                        <td>{item.name}</td>
                        <td className='text-center'>{item.users_count}</td>
                        <td className='text-center'>
                          <button className='btn btn-danger btn-sm px-3' onClick={id => handleDeleteModal(item.id)}>{t("delete")}</button>
                        </td>
                        <td className='text-center'>
                            <button className='btn btn-warning btn-sm px-3' onClick={(id, name) => handleEdit(item.id, item.name)}>{t("edit")}</button> 
                        </td>
                        <td className='text-center'><Link to={`/dashboard/saloon/${item.id}`} className='btn btn-success btn-sm px-3' >{t("details")}</Link></td>
                      </tr>
                    )) }
                </tbody>
              </Table>
            </div>
         : 
          <h6 className='text-center'> {t("hall has not been built yet")} </h6>
        }
        
        {editSaloon ? 
          <Modal show={editSaloon} onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title style={{fontSize: '1.1rem'}}>{t("edit this item")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={e => handleSubmit(e)}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>{t("saloon name")}</Form.Label>
                        <Form.Control
                            type="text"
                            name="name" 
                            value={name}
                            onChange={(e) => handleEditSaloon(e)} 
                          />
                        <Form.Text className="text-muted">
                            {t("Enter the new name you want for the salon")}
                        </Form.Text>
                        <span className='validator_error'>{validator.current.message('name', name, 'required')}</span>
                    </Form.Group>
                    <button className='btn green-btn col-md-3 offset-md-9' type="submit">
                        {t("submit")}
                    </button>
                </Form>
            </Modal.Body>
        </Modal>
        : ''}

        {deleteSaloon ? 
          <Modal show={deleteSaloon} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>{t("delete this item")} </Modal.Title>
            </Modal.Header>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t("Cancel")}
                </Button>
                <Button variant="danger" onClick={handleDelete}>
                    {t("confirm")}
                </Button>
            </Modal.Footer>
        </Modal>
        : ''}
    </> 
    );
}

export default Saloons

